var _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.264 8.07422H8.03564C7.44914 8.07422 6.97314 8.55022 6.97314 9.13672C6.97314 9.72322 7.44914 10.1992 8.03564 10.1992H18.264C18.8505 10.1992 19.3265 9.72322 19.3265 9.13672C19.3265 8.55022 18.8505 8.07422 18.264 8.07422Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.691 14.0059H7.60531C7.25636 14.0059 6.97314 14.4819 6.97314 15.0684C6.97314 15.6549 7.25636 16.1309 7.60531 16.1309H13.691C14.0399 16.1309 14.3231 15.6549 14.3231 15.0684C14.3231 14.4819 14.0399 14.0059 13.691 14.0059Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1161 19.9219H7.85926C7.36985 19.9219 6.97266 20.3979 6.97266 20.9844C6.97266 21.5709 7.36985 22.0469 7.85926 22.0469H11.1161C11.6055 22.0469 12.0027 21.5709 12.0027 20.9844C12.0027 20.3979 11.6055 19.9219 11.1161 19.9219Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_924_22143",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 30
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 0.833984H25.9833V29.0395H0.25V0.833984Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_924_22143)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5373 2.95898L7.64451 2.96465C4.34651 2.98448 2.37451 5.02448 2.37451 8.42307V21.4507C2.37451 24.872 4.36493 26.9148 7.69551 26.9148L18.5883 26.9106C21.8863 26.8907 23.8583 24.8479 23.8583 21.4507V8.42307C23.8583 5.00182 21.8693 2.95898 18.5373 2.95898ZM7.69693 29.0398C3.24293 29.0398 0.249512 25.9897 0.249512 21.4507V8.42307C0.249512 3.84298 3.14943 0.866568 7.63743 0.839651L18.5358 0.833984H18.5373C22.9913 0.833984 25.9833 3.88407 25.9833 8.42307V21.4507C25.9833 26.0294 23.0833 29.0072 18.5953 29.0356L7.69693 29.0398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9089 21.0373H15.6898C15.9171 21.0373 16.13 20.9494 16.291 20.7884L20.7829 16.2965C20.9671 16.1123 21.0688 15.867 21.0688 15.6062C21.0688 15.3448 20.9671 15.0989 20.7829 14.9147L20.0549 14.1867C19.6738 13.8068 19.0541 13.8068 18.6724 14.1867L14.202 18.657C14.0471 18.812 13.9592 19.0178 13.9538 19.2361L13.9089 21.0373ZM15.6897 21.93H13.4488C13.328 21.93 13.2119 21.8809 13.1276 21.7942C13.0432 21.7081 12.9971 21.5914 13.0001 21.47L13.0564 19.2094C13.0677 18.7595 13.249 18.3366 13.5672 18.0177H13.5678L18.0382 13.5474C18.7692 12.8175 19.9579 12.8175 20.6889 13.5474L21.4169 14.2754C21.7716 14.6295 21.9666 15.1003 21.966 15.6016C21.966 16.1029 21.771 16.5731 21.4169 16.9266L16.925 21.4185C16.5953 21.7481 16.1563 21.93 15.6897 21.93Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.5389130994b80e2e57b8db433311e100.svg";
export { ForwardRef as ReactComponent };